export default{
    peomessage:{
        btnState:{
            btn1:'保存',
            btn2:'保存成功'
        },
        fromtitle:{
            from1:'用户头像',
            from2:'昵称',
            from3:'姓名',
            from4:'性别',
            from5:'联系电话',
            from6:'业务联系邮箱',
            from7:'所在地区',
            from8:'详细地址',
            from9:'男',
            from10:'女',
        },
        placeholderlist:{
            pla1:'请输入昵称',
            pla2:'请输入真实姓名',
            pla3:'请输入联系电话',
            pla4:'请输入业务联系邮箱',
            pla5:'请输入详细地址信息',
            pla6:'请选择所在地区',
        },
        rulesMessage:{
            rule1:'请输入正确邮箱的格式',
            rule2:'请输入昵称',
            rule3:'请输入姓名',
            rule4:'请选择性别',
            rule5:'请输入电话',
            rule6:'请输入正确的手机号码',
            rule7:'请输入邮箱',
            rule8:'请选择所在地区!',
            rule9:'请输入详细地址!',
            rule10:'请上传正确的图片格式!',
            rule11:'上传图片大小不能超过10MB哦',
            rule12:'为了更好的帮您解决问题，请上传图片，图片大小不超过10M，支持jpg,png,jpeg格式文件'
        }
    }
}